import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'ax-sales-sales-registration-page',
    templateUrl: './sales-registration-page.component.html',
    styleUrl: './sales-registration-page.component.scss',
})
export class SalesRegistrationPageComponent {}
